import { useQuery } from "@tanstack/react-query";

import { getGetMessagesQueryKey, getMessages } from "@/api/orval/user/user";
import { useUser } from "modules/user";

import { readMessageIds } from "./readMessages";

const MESSAGES_STALE_TIME_MS = 1000 * 60 * 2;

/** Unread texts among the newest page, which is all the Account menu badge needs. */
export const useUnreadMessageCount = (): number => {
  const { user } = useUser();
  const { data } = useQuery({
    queryKey: getGetMessagesQueryKey({ page: 1 }),
    queryFn: ({ signal }) => getMessages({ page: 1 }, undefined, signal),
    staleTime: MESSAGES_STALE_TIME_MS,
    enabled: Boolean(user),
  });

  if (!user || !data) return 0;

  const readIds = readMessageIds(user.id);

  return data.items.filter((message) => !readIds.has(message.id)).length;
};
